import { useLocation } from "react-router-dom-v5-compat";

import SignUpFormBottomLink from "features/sign-up/components/SignUpFormBottomLink";
import SignUpFormButtons from "features/sign-up/components/SignUpFormButtons";

import { SignInCardAppsContainerProps } from "../containers/SignInCardContainer";
import SignInCardFlowsContainer from "../containers/SignInCardFlowsContainer";
import { ModalWrapper } from "../ModalWrapper";
import { RenderSignInFormProps } from "../SignInCardCommon";

export default function SignInCardPlurallApp(
  props: SignInCardAppsContainerProps
) {
  const location = useLocation();

  const renderForm = (renderProps: RenderSignInFormProps) => (
    <ModalWrapper
      errorMessage={renderProps.errorMessage}
      headerMessage={renderProps.headerMessage}
      defaultHeaderMessage="Login"
      subHeading="Welcome back"
    >
      <SignUpFormButtons
        setErrorMessage={renderProps.setErrorMessage}
        redirectAuthenticatedUserTo={renderProps.redirectAuthenticatedUserTo}
      />
      <SignUpFormBottomLink
        bottomText="Don't have an account?"
        bottomLink={{ ...location, pathname: props.linkToSignUp }}
        bottomLinkText="Sign up"
      />
    </ModalWrapper>
  );

  return (
    <SignInCardFlowsContainer {...props}>{renderForm}</SignInCardFlowsContainer>
  );
}
